import { IonModal, IonHeader, IonToolbar, IonTitle, IonButton, IonContent } from "@ionic/react";
import React from "react";
import avatarsSprite from '../../assets/icons/avatars.svg';
import defaultAvatar from '../../assets/icons/defaultavatar.svg';
const getAvatarOptions = () => {
    // Try to extract avatar IDs from the SVG sprite
    try {
        return [
            'alien',
            'robot',
            'ninja',
            'unicorn',
            'pirate',
            'devil',
            'ghost',
            'chef',
            'cat',
            'astronaut',
            'vampire',
            'clown',
            'mummy',
            'zombie',
            'pumpkin',
            'penguin',
            'koala',
            'lion',
            'panda',
            'frog',
            'avocado',
            'cupcake',
            'sloth',
            'cow',
            'octopus',
            'owl',
            'cookie',
            'cactus',
            'burger',
            'bunny',
            'superhero',
            'ice-cream',
            'wizard',
            'gamer',
            'pig',
            'coffee',
            'farmer',
            'sheep',
            'rocket',
            'dinosaur',
            'taco',
            'monkey',
            'jellyfish',
            'sushi',
            'bee',
            'llama',
            'crab',
            'detective',
            'raccoon',
            'space-invader'
        ];
    } catch (error) {
        console.error("Error parsing avatar sprite:", error);

        // Fallback to the static list in case of error
        return [
            'default'];
    }
};

// Avatar selector component
interface AvatarSelectorProps {
    isOpen: boolean;
    onClose: () => void;
    onSelect: (avatarId: string) => void;
    currentAvatar?: string;
}
export const isCustomAvatar = (avatar?: string): boolean => {
    return !!(avatar && !avatar.match(/^[a-z-]+$/));
};

const AvatarSelector: React.FC<AvatarSelectorProps> = ({
    isOpen,
    onClose,
    onSelect,
    currentAvatar
}) => {
    const avatarOptions = getAvatarOptions();

    return (
        <IonModal isOpen={isOpen} onDidDismiss={onClose}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Select Avatar</IonTitle>
                    <IonButton slot="end" onClick={onClose}>Close</IonButton>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <div className="p-4 grid grid-cols-3 gap-4">
                    {(avatarOptions || [])?.map((avatarId: any) => (
                        <div
                            key={avatarId}
                            className={`
                avatar-option bg-gray-500 relative rounded-lg overflow-hidden
                ${currentAvatar === avatarId ? 'border-4 border-[#05ACD9]' : 'border border-gray-200'}
              `}
                            onClick={() => {
                                onSelect(avatarId);
                                onClose();
                            }}
                        >
                            <div className="pb-[100%]">
                                {avatarId ? <svg
                                    className="absolute inset-0 w-full h-full"
                                    viewBox="0 0 200 200"
                                >
                                    <use href={`${avatarsSprite}#${avatarId}`} />


                                </svg> :
                                    <img alt="" src={defaultAvatar}></img>
                                }
                            </div>
                            <div className="p-1 text-center text-xs capitalize bg-[#f5f5f5]">
                                {avatarId}
                            </div>
                        </div>
                    ))}
                </div>
            </IonContent>
        </IonModal>
    );
};
export default AvatarSelector;
